export default "__VITE_ASSET__B15xQ4$Y__"